import { ImageScaleView, ImageScaleViewOpts } from '@play-co/timestep-core/ui';
import LangBitmapFontTextView from 'src/lib/ui/components/LangBitmapFontTextView';

type CardsBadgeOpts = ImageScaleViewOpts & {
  text?: string;
};

export class CardsBadge extends ImageScaleView {
  private text: LangBitmapFontTextView;

  constructor(opts: CardsBadgeOpts) {
    super({
      width: 101,
      height: 101,
      image: 'assets/ui/cards/common/icon_badge.png',
      centerOnOrigin: true,
      ...opts,
    });

    this.text = new LangBitmapFontTextView({
      superview: this,
      x: this.style.width / 2 - 2,
      y: this.style.height / 2,
      align: 'center',
      verticalAlign: 'center',
      centerOnOrigin: true,
      size: 16,
      font: 'Body',
      color: '#FFFFFF',
      width: this.style.width - 20,
      height: this.style.height - 20,
      r: -0.3,
    });

    if (opts.text) {
      this.setText(opts.text);
    }
  }

  public setText(text: string) {
    this.text.localeText = () => text;
  }
}
